import { createContext } from 'react'

export const WorkspaceShowContext = createContext(null)
